var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"butt",class:{bgcGray:_vm.buttonStatus},attrs:{"type":_vm.type,"size":_vm.size,"round":_vm.round,"loading":_vm.buttonStatus,"disabled":_vm.disabled,"plain":_vm.plain},on:{"click":_vm.onclick}},[_vm._v(_vm._s(_vm.title)+"\n"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }